const businessTransactionKey = '/business-transaction';

export const fetchAllBusinessTransactions = (query: string) =>
  `${businessTransactionKey}/all?${query}`;

export const fetchBusinessTransactionById = (id: string) =>
  `${businessTransactionKey}/${id}`;
